import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import Loading from "../../Components/LoadingComponent";
import { Auth } from "../../store/ducks/auth/types";
import { ApplicationState } from "../../store";
import { doLoginApp, loginRequest} from "../../store/ducks/auth/actions";
import { PING_CONFIG } from "../../Route/AppRouter";
import {
  canAccessAdminPanel,
  canAccessStudentPortal,
  getDefaultAuthenticatedPath,
} from "../../config/auth/accessControl";
import { formatAuthError, getAuthError } from "../../config/auth/authErrors";

import { clearSession, setUserId } from "../../config/cookies";

const PingIdentify = ({authorized, loginRequest, auth, doLoginApp }: any) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const code = searchParams.get("code");
  const navigateLogout = PING_CONFIG.logoutAuth as string;

  // ---------- HANDLERS ---------
  const handleLogin = (loginDefs: Auth) => {
    if (loginDefs.isExpirado) {
        alert(
          "Atenção\nNão foi possivel realizar login, seu usuário esta inativado. Procure um Administrador!"
        );     
        clearSession();
        window.location.replace(navigateLogout);
      return;
    }

    if (
      !canAccessStudentPortal(loginDefs) &&
      !canAccessAdminPanel(loginDefs)
    ) {
      alert(
        "Atenção\nSeu perfil não possui acesso ao Portal do Aluno nem ao Painel Administrativo. Procure um Administrador!"
      );
      clearSession();
      window.location.replace(navigateLogout);
      return;
    }

    doLoginApp(loginDefs);
    navigate(getDefaultAuthenticatedPath(loginDefs), { replace: true });
  };
  
  // ---------- EFFECTS ----------
  const requested = useRef(false);

  useEffect(() => {
    if (code && !requested.current) {
      requested.current = true;

      loginRequest(code);
    }
  }, [code]);

  useEffect(() => {
    if (!auth?.data?.idUsuario) return;

    setUserId(auth.data.idUsuario);
    if (!auth.error && auth.data != null) { 
      handleLogin(auth.data);
    }
  }, [
    auth?.data?.icAcessoPainelAdm,
    auth?.data?.icAcessoPortalAluno,
    auth?.data?.idUsuario,
  ]);

  useEffect(() => {
    if (!auth || !auth.data) return;

    if (authorized) {
        navigate(getDefaultAuthenticatedPath(auth.data), { replace: true });

        return;
      }

    if (!code) {
        alert("Acesso não permitido. Por favor, entre em contato com o time de treinamento da Claro.");
          clearSession();
          window.location.replace(navigateLogout);
          
        return;
      }

    if (!auth.error || !auth.errorMessage) return;

    alert(formatAuthError(getAuthError(auth.errorMessage.data?.code)));

    clearSession();
    window.location.replace(navigateLogout);
  }, [auth?.error, auth?.errorMessage]);
  
  return (
    <Loading loading={true} />
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ doLoginApp, loginRequest }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PingIdentify);
